import React, { FC, useContext, useEffect, useState } from 'react';
import { Navigate, Routes as ReactRoutes, Route } from 'react-router-dom';

import { isEmptyObj } from 'src/common/helpers';
import DerivativeWrapper from 'src/pages/derivatives/DerivativeWrapper';
import { NotFoundPage } from 'src/pages/not-found';
import SpotWrapper from 'src/pages/spot/SpotWrapper';
import { APP_URLS } from 'src/setup/client/app-urls';
import SocketContext from 'src/setup/socket/socketContext';

const Routes: FC = () => {
    const { sockets } = useContext(SocketContext);
    const [mainComponentKey, setMainComponentKey] = useState(0);

    useEffect(() => {
        // TODO:: Needs to handle in better way
        const handleVisibilityChange = () => {
            if (isEmptyObj(sockets)) {
                setMainComponentKey((prev) => prev + 1);
            }
        };
        window.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [sockets]);

    return (
        <ReactRoutes key={mainComponentKey}>
            <Route path="/" element={<Navigate to={'/contract'} replace />} />

            <Route path={`${APP_URLS.SPOT}/:symbolId?`} element={<SpotWrapper />} />

            <Route path={`${APP_URLS.CONTRACT}/:symbolId?`} element={<DerivativeWrapper />} />

            <Route path="/*" element={<NotFoundPage />} />
        </ReactRoutes>
    );
};

export default Routes;
